var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3H4.5C4.23478 3 3.98043 3.10536 3.79289 3.29289C3.60536 3.48043 3.5 3.73478 3.5 4V10C3.5 10.2652 3.60536 10.5196 3.79289 10.7071C3.98043 10.8946 4.23478 11 4.5 11H10.5C10.7652 11 11.0196 10.8946 11.2071 10.7071C11.3946 10.5196 11.5 10.2652 11.5 10V4C11.5 3.73478 11.3946 3.48043 11.2071 3.29289C11.0196 3.10536 10.7652 3 10.5 3ZM20.5 3H14.5C14.2348 3 13.9804 3.10536 13.7929 3.29289C13.6054 3.48043 13.5 3.73478 13.5 4V10C13.5 10.2652 13.6054 10.5196 13.7929 10.7071C13.9804 10.8946 14.2348 11 14.5 11H20.5C20.7652 11 21.0196 10.8946 21.2071 10.7071C21.3946 10.5196 21.5 10.2652 21.5 10V4C21.5 3.73478 21.3946 3.48043 21.2071 3.29289C21.0196 3.10536 20.7652 3 20.5 3ZM10.5 13H4.5C4.23478 13 3.98043 13.1054 3.79289 13.2929C3.60536 13.4804 3.5 13.7348 3.5 14V20C3.5 20.2652 3.60536 20.5196 3.79289 20.7071C3.98043 20.8946 4.23478 21 4.5 21H10.5C10.7652 21 11.0196 20.8946 11.2071 20.7071C11.3946 20.5196 11.5 20.2652 11.5 20V14C11.5 13.7348 11.3946 13.4804 11.2071 13.2929C11.0196 13.1054 10.7652 13 10.5 13ZM18.5 14H16.5V16H14.5V18H16.5V20H18.5V18H20.5V16H18.5V14Z",
    fill: "#0E60B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.47e701a65083989db4d969d32baa7700.svg";
export { ForwardRef as ReactComponent };